import { render, staticRenderFns } from "./VtmTable.vue?vue&type=template&id=7e741682&scoped=true&"
import script from "./VtmTable.vue?vue&type=script&lang=js&"
export * from "./VtmTable.vue?vue&type=script&lang=js&"
import style0 from "./VtmTable.vue?vue&type=style&index=0&id=7e741682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e741682",
  null
  
)

export default component.exports